import { createCheckboxIn, createDivIn, createImgIn, createSpanIn, setElementInnerHTML, setElementOnClick } from '../../../../shared/scripts/ui_utils/DomUtils.ts';
import { UIMRoomPlayersChatController } from './UIMRoomPlayersChatController.ts';
import { CA } from '../../../../shared/scripts/analytics/Analytics.ts';
import { AnalyticEventCategory, AnalyticEventType } from '../../../../../shared/entity_datas/EntityDatas.ts';
import { socket } from '../../../../shared/scripts/EntryShared.ts';
import { UIRoomWarningController, WarningType } from '../../../../shared/scripts/ui_html/room_warning/UIRoomWarningController.ts';
import { UIMRoomUserListController } from './UIMRoomUserListController.ts';
import { UIMDeviceHandler } from '../UIMDeviceHandler.ts';
import { LobbyImage } from '@colonist/types';
import { UIMInviteFriendsBottomDrawer } from '../../ui_popup/UIMInviteFriendsBottomDrawer.ts';
import { ClientUserState } from '../../../../shared/scripts/ClientUserState.ts';
import { UIGameSpriteHandler } from '../../../../shared/scripts/UIGameSpriteHandler.ts';
import { UIRoomSettingsController } from '../../../../shared/scripts/ui_room/UIRoomSettingsController.ts';
import { AudioManager, AudioType } from '@colonist/audio';
import { UIUtilsEjsVariables } from '../../../../shared/scripts/UIUtilsEjsVariables.ts';
import { UIMDiscordActivityController } from '../../discord/UIMDiscordActivityController.ts';
export class UIMRoomPlayersController {
    renderPlayerCards(roomState) {
        this.playersCount = roomState.getSessionCount();
        this.userList.update(roomState);
    }
    renderBottomButtons() {
        if (this.bottomButtonsContainer.hasChildNodes()) setElementInnerHTML(this.bottomButtonsContainer, {
            key: 'strings:colonistCommon.utils.emptyString'
        });
        this.createSharingContainer();
        this.renderInviteFriendsButton();
        this.renderCopyLinkButton();
    }
    createSharingContainer() {
        this.sharingContainer = createDivIn(this.bottomButtonsContainer, 'm-room-players-sharing-container');
    }
    renderInviteFriendsButton() {
        var _ClientUserState_userState;
        if (!((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.isLoggedIn)) return;
        this.inviteFriendsButton = createDivIn(this.sharingContainer, 'm-button-cta-secondary-orange');
        setElementOnClick(this.inviteFriendsButton, ()=>{
            const eventData = {
                type: AnalyticEventType.ClickedInviteFriendButton,
                category: AnalyticEventCategory.MobileAnalytics
            };
            void CA.sendAnalyticEventsWithMobileDimensions(eventData);
            new UIMInviteFriendsBottomDrawer();
        });
        setElementInnerHTML(this.inviteFriendsButton, {
            key: 'strings:roomPage.inviteFriends'
        });
    }
    renderCopyLinkButton() {
        this.copyLinkButton = createDivIn(this.sharingContainer, 'm-button-cta-secondary-dark-overlay');
        createImgIn(this.copyLinkButton, LobbyImage.Share, '');
        setElementOnClick(this.copyLinkButton, ()=>this.onCopyLinkButtonClick(window.location.href));
        if (this.isHost) {
            this.startGameButton = createDivIn(this.bottomButtonsContainer, 'm-button-cta-secondary');
            setElementInnerHTML(this.startGameButton, {
                key: 'strings:roomPage.startGame'
            });
            setElementOnClick(this.startGameButton, ()=>UIRoomWarningController.runWithWarning(async ()=>{
                    AudioManager.play(AudioType.Click);
                    await UIGameSpriteHandler.continueAfterAssetsLoad();
                    UIRoomSettingsController.snapshotRoomSettings(this.roomState, socket.controller.session.id);
                    socket.roomClient.startGame();
                }, WarningType.StartGameVPExceededRecommendedLimit, this.roomState));
        } else {
            const readyContainer = createDivIn(this.bottomButtonsContainer, 'm-room-players-ready-container');
            createSpanIn(readyContainer, '', {
                key: 'strings:roomPage.imReady'
            });
            this.readyCheckboxContainer = createCheckboxIn(readyContainer, '', '', (e)=>{
                e.preventDefault();
                UIRoomWarningController.runWithWarning(async (userAgreed)=>{
                    if (userAgreed) this.readyCheckboxContainer.checked = true;
                    await UIGameSpriteHandler.continueAfterAssetsLoad();
                    socket.roomClient.setReadyToStart(this.readyCheckboxContainer.checked);
                }, WarningType.ReadyUpVPExceededRecommendedLimit, this.roomState);
            });
        }
    }
    onCopyLinkButtonClick(roomLink) {
        AudioManager.play(AudioType.Click);
        if (UIUtilsEjsVariables.isUserOnDiscord) {
            this.shareRoomOnDiscord();
            this.onCopyButtonClick();
            void this.sendCopyLinkAnalytic();
            return;
        }
        const url = new URL(roomLink);
        const cleanedRoomLink = `https://${url.host}/#${this.roomState.gameSetting.id}`;
        UIMDeviceHandler.sendShareLink(cleanedRoomLink);
        this.onCopyButtonClick();
        void this.sendCopyLinkAnalytic();
    }
    shareRoomOnDiscord() {
        UIMDiscordActivityController.getInstance().inviteFriendsToRoom(this.roomState.gameSetting.id);
    }
    sendCopyLinkAnalytic() {
        const copyLinkEvent = {
            type: AnalyticEventType.CopiedRoomLink,
            category: AnalyticEventCategory.Lobby,
            stringValue: this.roomState.gameSetting.id
        };
        void CA.sendAnalyticEventOnce(copyLinkEvent);
    }
    onCopyButtonClick() {
        const innerHTML = this.copyLinkButton.innerHTML;
        this.copyLinkButton.innerText = '';
        createDivIn(this.copyLinkButton, 'loading-icon');
        setTimeout(()=>{
            // eslint-disable-next-line no-restricted-syntax
            this.copyLinkButton.innerHTML = innerHTML;
        }, 2000);
    }
    static areGuestsReadyToStart(roomState) {
        for (const guest of roomState.getGuestSessions()){
            if (!guest.isReadyToPlay) return false;
        }
        return true;
    }
    changeStartGameButtonState(roomState) {
        if (!this.isHost) return;
        if (UIMRoomPlayersController.areGuestsReadyToStart(roomState)) {
            this.startGameButton.classList.remove('m-button-disabled');
            this.startGameButton.innerText = 'Start Game';
            setElementOnClick(this.startGameButton, ()=>UIRoomWarningController.runWithWarning(async ()=>{
                    AudioManager.play(AudioType.Click);
                    await UIGameSpriteHandler.continueAfterAssetsLoad();
                    socket.roomClient.startGame();
                }, WarningType.StartGameVPExceededRecommendedLimit, roomState));
            return;
        }
        this.startGameButton.classList.add('m-button-disabled');
        this.startGameButton.innerText = 'Waiting for everyone to be ready...';
        setElementOnClick(this.startGameButton, ()=>undefined);
    }
    // eslint-disable-next-line class-methods-use-this
    updateIAmReadyCheckbox(roomState) {
        const readyCheckbox = document.querySelector('.m-room-players-ready-container input');
        if (readyCheckbox == null) return;
        for (const guest of roomState.getGuestSessions()){
            if (socket.controller.session.id != guest.userSessionId) continue;
            readyCheckbox.checked = guest.isReadyToPlay;
        }
    }
    handleSounds(roomState) {
        const oldPlayerCount = this.playersCount;
        const newPlayerCount = roomState.getSessionCount();
        if (oldPlayerCount > newPlayerCount) AudioManager.play(AudioType.Disconnect);
        if (oldPlayerCount < newPlayerCount) AudioManager.play(AudioType.JoinRoom);
    }
    update(roomState) {
        this.roomState = roomState;
        const isHost = roomState.isHost(socket.controller.session.id);
        const hostHasChanged = this.isHost != isHost;
        if (hostHasChanged) {
            this.isHost = isHost;
            this.renderBottomButtons();
        }
        this.handleSounds(roomState);
        this.changeStartGameButtonState(roomState);
        this.renderPlayerCards(roomState);
        this.updateIAmReadyCheckbox(roomState);
        this.userList.update(roomState);
        setElementOnClick(this.copyLinkButton, ()=>this.onCopyLinkButtonClick(window.location.href));
    }
    constructor(container, roomState){
        this.playersCount = 0;
        this.container = container;
        this.roomState = roomState;
        this.isHost = this.roomState.isHost(socket.controller.session.id);
        this.playersContainer = createDivIn(this.container, 'm-room-players-container');
        this.chatController = new UIMRoomPlayersChatController(this.container);
        this.bottomButtonsContainer = createDivIn(this.container, 'm-room-players-bottom-buttons-container');
        this.playersCount = roomState.getSessionCount();
        this.userList = new UIMRoomUserListController(this.playersContainer);
        this.userList.load(roomState);
        this.handleSounds(roomState);
        this.renderBottomButtons();
    }
}
